kv.controller('travelOrderEditCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
    var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
    vm.primaryKey = 'travel_order_id';
    vm.entity = 'travel_order';
    vm.rest = vm.getInjection('resource').init(vm.entity);
    vm.validator = vm.getInjection('validator');

    // let cmdate = vm.getInjection('cmdate');

    var REST = resource.init(vm.entity);
    let url_segments = window.location.pathname.split( '/' );
    let page_entity_id = url_segments[2];
    let page_identifier = url_segments[3];

    if(page_identifier == 'edit') {
        $http.get("/travel_order/" + page_entity_id).then(function(response) {
            vm.data = response.data;
        });
    } else {
        let defaultObjects = JSON.parse($element.find("#defaultObjects").attr("defaultObjects"));
        vm.data = defaultObjects;
        vm.data.series = vm.bladeParams.series;
        vm.data.number = vm.bladeParams.number;
        vm.isNewRecord = true;
        vm.isNewRecord = true;
        vm.data.user= [];
        vm.data.user_id = API.user.user_id;
        vm.data.user.full_name = API.user.full_name;
        vm.data.tenant_fiscal_entity_id = vm.data.tenant_fiscal_entity.tenant_fiscal_entity_id;

    }

    vm.newEntity = function newEntity(entity) {
        if(!vm.data) {
            vm.data = {};
        }

        if(!vm.data[entity]) {
            return vm.data[entity] = [{}];
        }

        return vm.data[entity].push({});
    };

    $scope.$watch('vm.data.series', function (value) {
        if (value && vm.data.number && vm.data.number !== null) {
            vm.data.serial_number = vm.data.series.concat(vm.data.number);
            vm.data.serial_number = vm.data.serial_number.replace(/\s+/g, '');
        }
    });

    $scope.$watch('vm.data.number', function (value) {
        if (value) {
            var nb = vm.data.number;
            vm.data.number= nb.toString().replace(/\s+/g, '');
            if(!vm.data.series || vm.data.series == null){
                vm.data.series = "";
            }
            vm.data.serial_number = vm.data.series.concat(vm.data.number);
            vm.data.serial_number = vm.data.serial_number.replace(/\s+/g, '');
        }
    });

    vm.deleteEntity = function deleteEntity($index, entity, id) {
        if(!id) {
            return vm.data[entity].splice($index,1);
        }

        if(page_entity_id) {
            REST.delete({
                url: vm.entity + '/:id/' + entity + '/:entityId',
                params: {
                    id: page_entity_id,
                    entityId: id
                }
            }).then(function(data) {
                vm.data[entity].splice($index,1);
            });
        }
    };

    vm.prepareDataToSave = function () {
        let postData = angular.copy(vm.data);
        if(postData.all_day === 1){
            postData.date_to = postData.date_from;
        }
        // used for validations: if contract is normal created, do validations, else not (case project, where required data is sent from backend)
        postData.basic_create = true;
        return postData;
    };

    return vm;
});
